var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from "react";
import { Checkbox } from "@bolteu/kalep-react";
export var CheckboxField = function CheckboxFieldComponent(_a) {
  var onChange = _a.onChange,
    value = _a.value,
    _compact = _a.compact,
    validatorResults = _a.validatorResults,
    rest = __rest(_a, ["onChange", "value", "compact", "validatorResults"]);
  var handleChange = React.useCallback(function (change) {
    onChange({
      value: !!change.target.checked
    });
  }, [onChange]);
  var hasError = !!(validatorResults === null || validatorResults === void 0 ? void 0 : validatorResults[0]);
  return /*#__PURE__*/React.createElement(Checkbox, Object.assign({
    checked: value !== null && value !== void 0 ? value : false,
    onChange: handleChange,
    error: hasError
  }, rest));
};